/**
 * @generated SignedSource<<f0f20c5179f9033eb33b35b50134d703>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifyCodeStepProfileProfile_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly name: string;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "VerifyCodeStepProfileProfile_session";
};
export type VerifyCodeStepProfileProfile_session$key = {
  readonly " $data"?: VerifyCodeStepProfileProfile_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"VerifyCodeStepProfileProfile_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VerifyCodeStepProfileProfile_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "82c310c952db7cce280420d75beef90f";

export default node;
